// Port of NativeHud::archiveTrackList and UiMotion::ReelCurve (Rhine, MIT).
export class TrackReel {
  constructor(element, reduced) { this.element=element; this.reduced=reduced; this.nodes=new Map(); this.position=0; this.velocity=0; this.list=null; }
  sample(now) {
    if(!this.points)return [this.position,0];
    const p=Math.max(0,Math.min(1,(now-this.start)/640))*48,i=Math.floor(p);
    return i>=48?[this.points[48],0]:[this.points[i]+(this.points[i+1]-this.points[i])*(p-i),(this.points[i+1]-this.points[i])*48/.64];
  }
  update(list, selected) {
    const now=performance.now(),same=this.list===list;
    let [from,velocity]=this.sample(now);
    if(!same||this.reduced()||Math.abs(selected-from)>8) {from=selected;velocity=0;}
    if(same&&this.target===selected&&!this.reduced())return;
    this.list=list;this.target=selected;this.start=now;
    const displacement=from-selected,cap=Math.max(Math.abs(displacement),1)*12/.64;
    const impulse=Math.max(-cap,Math.min(cap,velocity))*.64;
    this.points=Array.from({length:49},(_,i)=>i===48?selected:selected+(displacement+(impulse+10*displacement)*i/48)*Math.exp(-10*i/48));
    cancelAnimationFrame(this.frame);
    const draw=time=>{[this.position,this.velocity]=this.sample(time);this.paint();if(time-this.start<640&&!this.reduced())this.frame=requestAnimationFrame(draw);};
    draw(now);
  }
  paint() {
    const wanted=new Set();
    for(let i=Math.max(0,Math.floor(this.position)-5);i<=Math.min(this.list.length-1,Math.ceil(this.position)+5);i++) {
      const relative=i-this.position,d=Math.abs(relative),opacity=Math.max(0,Math.min(1,5-d));
      if(!opacity)continue;wanted.add(i);
      let button=this.nodes.get(i);
      if(!button) {button=document.createElement('button');button.dataset.action='select';button.dataset.index=i;button.innerHTML='<span class="reel-title"></span><span class="reel-rule" aria-hidden="true"></span>';this.nodes.set(i,button);this.element.append(button);}
      button.firstElementChild.textContent=this.list[i].title;
      button.setAttribute('aria-current',String(i===this.target));
      const offset=Math.sign(relative)*(d<=1?d*88:88+(d-1)*52),emphasis=Math.max(0,1-d);
      button.style.transform=`translateY(${offset}px)`;button.style.opacity=opacity;
      button.style.setProperty('--emphasis',emphasis);button.style.setProperty('--tick',`${14+36*emphasis}px`);
    }
    for(const [i,node] of this.nodes)if(!wanted.has(i)){node.remove();this.nodes.delete(i);}
  }
}
